<template>
  <section class="referral-request">
    <div class="top-header">
      <h2>Referral Requests</h2>
      <div
        v-if="isActivated"
        class="header-right">
        <span>Limit: {{ customerDetail.referral_request_total_num }}</span>
        <v-button @click="onEditLimit">Edit Limit</v-button>
        <v-button
          type="primary"
          plain
          icon="plus"
          @click="onNewRequest">New Request</v-button>
      </div>
    </div>

    <template v-if="isActivated">

      <div class="transparent">
        <el-table
          :data="tableData"
          style="width: 100%"
          class="table-pointer"
          stripe
          @row-click="handlerRow">
          <el-table-column
            label="Date">
            <template #default="{ row }">
              <span class="block">{{ row.admin_create_date }}</span>
              <span class="fs-12">{{ row.admin_create_time }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Referee">
            <template #default="{ row }">
              <span class="bold block">{{ row.name }}</span>
              <span class="fs-12">{{ row.phone }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="product_language"
            label="Product Type">
          </el-table-column>
          <el-table-column
            prop="status_language"
            label="Status">

          </el-table-column>
        </el-table>
      </div>
      <v-pagination
        :total="pageConfig.total"
        :current="pageConfig.currentPage"
        @currentChange="currentChange" />
    </template>

    <div class="status-container">

      <template v-if="isIneligible">
        <font-awesome-icon
          icon="exclamation-triangle"
          class="ic-error" />
        <span class="fs-16 bold block mg-b-10">This account is ineligible for referral requests.</span>
        <span class="fs-14 block mg-b-10">To enable referral requests, complete this account with</span>
      </template>

      <template v-if="isEligible">
        <font-awesome-icon
          icon="info-circle"
          class="ic-info" />
        <span class="fs-16 bold block mg-b-10">This account is eligible for referral requests.</span>
        <span class="fs-14 block mg-b-10">If requested by the customer, click below to enable referral requests.</span>
      </template>


      <template v-if="isRequest || isRequestNew">
        <font-awesome-icon
          icon="comment-medical"
          class="ic-info" />
        <span class="fs-16 bold block mg-b-10">This customer has requested to enable referral requests.</span>
      </template>

      <span
        v-if="isRequest"
        class="fs-14 block mg-b-10">Their profile has been approved previously. Click below to enable referral requests.</span>

      <span
        v-if="isRequestNew"
        class="fs-14 block mg-b-10">They have submitted the following information to their profile.</span>

      <div
        v-if="!isActivated && !isRequestNew"
        class="status-box fs-14">
        <template v-if="isPersonal">
          <div class="status-item">
            <font-awesome-icon
              v-if="customerDetail.isrd_fst_nm"
              icon="check"
              class="ic-check" />
            <font-awesome-icon
              v-else
              icon="exclamation-circle"
              class="ic-warning" />
            <span>First Name</span>
          </div>
          <div class="status-item">
            <font-awesome-icon
              v-if="customerDetail.isrd_lst_nm"
              icon="check"
              class="ic-check" />
            <font-awesome-icon
              v-else
              icon="exclamation-circle"
              class="ic-warning" />
            <span>Last Name</span>
          </div>
          <div class="status-item">
            <font-awesome-icon
              v-if="isVerified"
              icon="check"
              class="ic-check" />
            <font-awesome-icon
              v-else
              icon="exclamation-circle"
              class="ic-warning" />
            <span>Approved HKID</span>
          </div>
        </template>

        <template v-else>
          <div class="status-item">
            <font-awesome-icon
              v-if="customerDetail.isrd_com_nm"
              icon="check"
              class="ic-check" />
            <font-awesome-icon
              v-else
              icon="exclamation-circle"
              class="ic-warning" />
            <span>Comapny Name</span>
          </div>
          <div class="status-item">
            <font-awesome-icon
              v-if="isVerified"
              icon="check"
              class="ic-check" />
            <font-awesome-icon
              v-else
              icon="exclamation-circle"
              class="ic-warning" />
            <span>BR</span>
          </div>
        </template>
      </div>

      <div
        v-if="isRequestNew"
        class="info-box fs-14">
        <template v-if="isPersonal">
          <div class="info-item">
            <span>First Name</span>
            <span>{{ customerDetail.isrd_fst_nm }}</span>
          </div>
          <div class="info-item">
            <span>Last Name</span>
            <span>{{ customerDetail.isrd_lst_nm }}</span>
          </div>
          <div class="info-item">
            <span>HKID</span>
            <span>{{ customerDetail.id_no }}</span>
          </div>
          <div
            v-if="customerDetail.id_type_pic"
            class="info-card">
            <img
              :src="customerDetail.id_type_pic.url"
              alt="" />
          </div>
        </template>
        <template v-else>
          <div class="info-item">
            <span>Comapny Name</span>
            <span>{{ customerDetail.isrd_com_nm }}</span>
          </div>
          <div class="info-item">
            <span>Business Registration Number</span>
            <span>{{ customerDetail.id_no }}</span>
          </div>
          <div
            v-if="customerDetail.id_type_pic"
            class="info-card">
            <img
              :src="customerDetail.id_type_pic.url"
              alt="" />
          </div>
        </template>
      </div>

      <div class="btn-container">
        <v-button
          v-if="isIneligible"
          @click="onComplete">Complete Profile</v-button>
        <v-button
          v-if="isEligible || isRequest"
          type="primary"
          plain
          @click="onEnableRequest">Enable Referral Requests</v-button>
        <v-button
          v-if="isRequestNew"
          type="primary"
          plain
          @click="onApproveEnable">Approve & Enable Referral Requests</v-button>
        <v-button
          v-if="isRequest || isRequestNew"
          @click="onReject">Reject</v-button>
      </div>

    </div>

    <edit-limit
      ref="edit-limit"
      :userId="customerDetail.id"
      :limit="customerDetail.referral_request_total_num"
      @update="emitUpdate" />
    <new-request
      ref="new-request"
      :userId="customerDetail.id"
      @update="handlerNewRequestSuccess" />
  </section>
</template>
<script>
import EditLimit from '../dialog/edit-limit'
import NewRequest from '../dialog/new-request'
import {getReferralRequestList, setAccountReferralStatus} from '@/api/request'

export default {
  name: 'ReferralRequest',
  components: {
    EditLimit,
    NewRequest
  },
  props: {
    // customerDetail: {
    //   type: Object,
    //   default: () => ({})
    // }
  },
  inject:['detailData'],
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      tableData: []
    }
  },
  computed: {
    customerDetail(){
      return this.detailData().customer_profile
    },
    userId() {
      return this.customerDetail.id
    },
    isPersonal() {
      const { identity } = this.customerDetail
      return identity === 1
    },
    referralRequestStts() {
      const { referral_request_stts } = this.customerDetail
      return referral_request_stts
    },
    isActivated() {
      return this.referralRequestStts === 1
    },
    isIneligible() {
      return this.referralRequestStts === -1 && !this.isVerified
    },
    isEligible() {
      return this.referralRequestStts === -1 && this.isVerified
    },
    isRequest() {
      // 前臺提交了申請
      return this.referralRequestStts === 0 && this.isVerified
    },
    isRequestNew() {
      // 前臺提交申請，新資料
      return this.referralRequestStts === 0 && !this.isVerified
    },
    isVerified() {
      const { verified } = this.customerDetail
      return verified > 1
    }
  },
  watch: {
    userId: {
      immediate: true,
      handler(val) {
        if(val) {
          this.handlerGetData()
        }
      }
    }
  },
  methods: {
    handlerRow(row) {
      const { ticket_id } = row
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id
        }
      })
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getReferralRequestList()
    },
    onEditLimit() {
      this.$refs['edit-limit'].changeDialog()
    },
    onNewRequest() {
      this.$refs['new-request'].changeDialog()
    },
    onComplete() {
      this.$emit('tab', 'profileTab')
    },
    onEnableRequest() {
      this.network().setAccountReferralStatus()
    },
    onReject() {
      this.network().setAccountReferralStatus({
        is_reject: 1
      })
    },
    onApproveEnable() {
      this.network().setAccountReferralStatus()
    },
    emitUpdate() {
      this.$emit('update')
    },
    handlerGetData() {
      this.pageConfig.currentPage = 1
      this.network().getReferralRequestList()
    },
    handlerNewRequestSuccess() {
      this.emitUpdate()
      this.handlerGetData()
    },
    network() {
      return {
        getReferralRequestList: async () => {
          const { data } = await getReferralRequestList({
            customer_id: this.customerDetail.id,
            page: this.pageConfig.currentPage
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        setAccountReferralStatus: async (params = {}) => {
          const { data } = await setAccountReferralStatus({
            user_id: this.customerDetail.id,
            ...params
          })
          this.$emit('update')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.referral-request {
    .fs-12 {
        font-size: 12px;
    }
    .fs-14 {
      font-size: 14px;
    }
    .fs-16 {
      font-size: 16px;
    }
    .bold {
        font-weight: bold;
    }
    .block {
        display: block;
    }
    .mg-b-10 {
      margin-bottom: 10px;
    }
    .top-header {
        display: flex;
        justify-content: space-between;
        h2 {
            font-size: 20px;
            color: #616266;
        }
        .header-right {
            span {
                display: inline-block;
                padding-right: 10px;
                font-size: 14px;
                color: #616266;
            }
        }
    }
    .status-container {
      margin-top: 50px;
      text-align: center;
      .ic-error {
        display: block;
        margin: 0 auto 30px auto;
        color: #CB2431;
        font-size: 32px;
      }
      .ic-info {
        display: block;
        margin: 0 auto 30px auto;
        color: #6A737D;
        font-size: 32px;
      }
      .status-box {
        .status-item {
          margin-bottom: 10px;
          & > span {
            display: inline-block;
            padding-left: 5px;
          }
          .ic-check {
            font-size: 14px;
            color: #28A745;
          }
          .ic-warning {
            font-size: 14px;
            color: #DBAB09;
          }
        }
      }
      .info-box {
        .info-item {
          span {
            display: block;
            padding-bottom: 10px;
          }
          span:first-child {
            font-weight: bold;
          }
        }
        .info-card {
          margin: 0 auto;
          width: 250px;
          img {
            width: 100%;
          }
        }
      }
      .btn-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 30px;
        .el-button {
          margin-bottom: 16px;
        }
      }
    }
}
</style>
